import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import { domOnlyProps } from 'utils/dom-only-props'
import Field from 'components/setupform-form/field'
import TextInput from 'components/setupform-form/field/text-input'
import TextArea from 'components/setupform-form/field/text-area'
import FieldError from 'components/setupform-form/field/field-error'
import Wysiwyg from '../wysiwyg'

import styles from './setupform-details-form.css'

const SetupformDetailsForm = ({ fields }) => (
  <form styleName="setupform-details-form">
    <Field
      description="Where can we find out more about your event?"
      name="Event URL"
    >
      <TextInput data={fields.eventUrl} placeholder="https://example.com" />
      <FieldError data={fields.eventUrl} />
    </Field>

    <Field
      description={
        'Only YouTube videos are currently supported.' +
        'A good, inspiring video boosts customer engagement.'
      }
      name="YouTube Video URL"
    >
      <TextInput data={fields.youtubeUrl} placeholder="https://www.youtube.com/embed/IDENTIFIER" />
      <FieldError data={fields.youtubeUrl} />
    </Field>

    <Field
      description={
        'This is to inform your customers about how they can get into your event.' +
        'It needs to be precise: for example, where customers can collect tickets from and when.'
      }
      name="Redemption Instructions"
    >
      <TextArea
        data={fields.redeemInstructions}
        placeholder={
          'Arrive at the [venue / box office / door] from [## hours / ## minutes] before the start time.' +
          'Provide your name, show you in-app ticket or booking confirmation email, and mention you booked on YPlan.'
        }
      />
      <FieldError data={fields.redeemInstructions} />
    </Field>

    <Field
      description="Add relevant terms and conditions that we need to let your customers know about."
      name="Terms & Conditions"
    >
      <Wysiwyg
        onChange={fields.terms.onChange}
        value={fields.terms.value}
        placeholder="e.g. Children under 16 must be accompanied by a responsible adult."
      />
      <FieldError data={fields.terms} />
    </Field>

    <Field
      description={
        'List of e-mails, seperated by a comma if you want more than one.' +
        'We\'ll email the final list of customers to all e-mails provided here, ' +
        'so that you can identify YPlanners when they arrive at your event.'
      }
      name="Callover list email addresses"
    >
      <TextInput data={fields.boxOfficeEmail} placeholder="person@example.com" />
      <FieldError data={fields.boxOfficeEmail} />
    </Field>

    <Field
      description="Phone number of the main event contact."
      name="Event contact phone number"
    >
      <TextInput data={fields.boxOfficePhone} placeholder="+44 2071 839 394" />
      <FieldError data={fields.boxOfficePhone} />
    </Field>

    <Field
      description="This is the full name of the main contact."
      name="Box office contact"
    >
      <TextInput data={fields.boxOfficeContact} placeholder="Firstname Lastname" />
      <FieldError data={fields.boxOfficeContact} />
    </Field>

    <Field
      description={
        'Select a time.' +
        'if you wish for earlier or later time than shown here please contact your Account Manager after submission.'
      }
      name="Call over time. When would you like to receive the attendee list?"
    >
      <select styleName="select" data={fields.offsaleTime} {...domOnlyProps(fields.offsaleTime)}>
        <option value="0">When the event starts</option>
        <optgroup label="Before the event starts:">
          <option value="5">5 minutes</option>
          <option value="10">10 minutes</option>
          <option value="30">30 minutes</option>
          <option value="45">45 minutes</option>
          <option value="60">60 minutes</option>
          <option value="90">90 minutes</option>
          <option value="120">120 minutes</option>
        </optgroup>
        <optgroup label="After the event starts:">
          <option value="-30">30 minutes</option>
          <option value="-60">60 minutes</option>
        </optgroup>
      </select>
      <FieldError data={fields.offsaleTime} />
    </Field>
  </form>
)

SetupformDetailsForm.propTypes = {
  fields: PropTypes.object,
}

export default CSSModules(SetupformDetailsForm, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-details-form/setupform-details-form.js
 **/